/*
  Nordicsell: kundlöftena bredvid logotypen + nedräkning i topprutañs
  "Just nu: heta deals"-knapp (.nstb-hot).

  Nedräkningen går till SÖNDAG 23:59:59 svensk tid och börjar om automatiskt
  när veckan vänder.

  ÄNDRAT 2026-08-16 (Hilton): räknaren pekar nu på NÄSTA söndag när man
  besöker sidan på en söndag, i stället för på kvällen samma dag. Det är
  raden `var add = 7 - wall.getUTCDay();` som styr det – med `% 7` på slutet
  landar den på dagens kväll i stället.

  Vill du ha ett fast slutdatum: byt ut nextDeadline() mot
  return new Date('2026-08-23T23:59:59+02:00');

  Tiden räknas alltid i Europe/Stockholm oavsett var besökaren befinner sig,
  och sommar-/vintertid hanteras via Intl i stället för fast UTC-offset.
*/
(function () {
  var LINKS = [
    { text: 'Fri frakt över 470 kr', href: '/pages/leverans' },
    { text: '30 dagars retur', href: '/pages/reklamation' },
    { text: 'Just nu: heta deals', href: '/collections/bastsaljare' }
  ];

  var TZ = 'Europe/Stockholm';

  function tzOffsetMs(date) {
    var f = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = {};
    f.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    var h = p.hour === '24' ? 0 : Number(p.hour);
    var asUTC = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), h, Number(p.minute), Number(p.second));
    return asUTC - date.getTime();
  }

  function nextDeadline() {
    var now = new Date();
    var off = tzOffsetMs(now);
    var wall = new Date(now.getTime() + off);
    var add = 7 - wall.getUTCDay();
    var cand = Date.UTC(wall.getUTCFullYear(), wall.getUTCMonth(), wall.getUTCDate() + add, 23, 59, 59, 999);
    var target = new Date(cand - off);
    if (target.getTime() <= now.getTime()) {
      var next = cand + 7 * 86400000;
      target = new Date(next - tzOffsetMs(new Date(next - off)));
    }
    return target;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function label(ms) {
    if (ms <= 0) return '';
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    if (d > 0) return d + ' d ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  var deadline = nextDeadline();

  function tick() {
    var el = document.querySelector('.nstb-hot .ns-deal-countdown');
    if (!el) return;
    var left = deadline.getTime() - Date.now();
    if (left <= 0) {
      deadline = nextDeadline();
      left = deadline.getTime() - Date.now();
    }
    var txt = label(left);
    if (el.textContent !== txt) el.textContent = txt;
  }

  function injectCountdown() {
    var hot = document.querySelector('.nstb-hot');
    if (!hot || hot.querySelector('.ns-deal-countdown')) return;
    if (!document.getElementById('ns-deal-countdown-style')) {
      var cs = document.createElement('style');
      cs.id = 'ns-deal-countdown-style';
      cs.textContent =
        '.nstb-hot .ns-deal-countdown{margin-inline-start:7px;padding-inline-start:7px;' +
        'border-inline-start:1px solid currentColor;font-variant-numeric:tabular-nums;' +
        'font-weight:700;letter-spacing:.02em;opacity:.95}' +
        '@media(max-width:520px){.nstb-hot .ns-deal-countdown{margin-inline-start:5px;padding-inline-start:5px}}';
      document.head.appendChild(cs);
    }
    var span = document.createElement('span');
    span.className = 'ns-deal-countdown';
    span.setAttribute('aria-label', 'Tid kvar av erbjudandet');
    hot.appendChild(span);
    tick();
  }

  function inject() {
    injectCountdown();
    /* ÄNDRAT 2026-10-14: kundlöftena läggs inte längre in bredvid loggan.
       De visas redan i toppbaren och var dolda här (display:none), men på
       startsidan hamnade de ändå INNE i sidans H1 (loggan), så att rubriken
       för sökmotorer blev "Nordicsell Fri frakt över 470 kr 30 dagars retur
       Just nu: heta deals". Ta bort raden nedan för att få tillbaka dem. */
    return;
    if (document.querySelector('.ns-usp-links')) return;
    var logo = document.querySelector('.header__top .header__logo');
    if (!logo) return;
    if (!document.getElementById('ns-usp-style')) {
      var st = document.createElement('style');
      st.id = 'ns-usp-style';
      st.textContent =
        '.header__top .header__logo{justify-content:flex-start}' +
        '.header__top .header__logo>a,.header__top .header__logo .header__heading{flex-shrink:0;white-space:nowrap}' +
        '.ns-usp-links{display:none;align-items:center;gap:20px;margin-inline-start:28px;white-space:nowrap;flex-shrink:0}' +
        '@media(min-width:1024px){.ns-usp-links{display:flex}}' +
        '.ns-usp-links a{font-size:13px;color:inherit;opacity:.85;text-decoration:none}' +
        '.ns-usp-links a:hover{opacity:1;text-decoration:underline;text-underline-offset:3px}' +
        '.ns-usp-links a:last-child{color:#c4301c;opacity:1;font-weight:600}';
      document.head.appendChild(st);
    }
    var wrap = document.createElement('nav');
    wrap.className = 'ns-usp-links';
    wrap.setAttribute('aria-label', 'Kundlöften');
    LINKS.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l.href;
      a.textContent = l.text;
      wrap.appendChild(a);
    });
    logo.appendChild(wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  setInterval(tick, 1000);

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      inject();
    }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
